import printPackingSlipComponent from './print_packing_slip.component';

let printPackingSlipModule = angular.module('printPackingSlip', [])

  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('printPackSlip', {
        url: '/print-pack-slip',
        component: 'printPackSlip',
        data: {
          requireLogin: true,
          requireACL: 'order_packing.all'
        }
      });
  })

  .component('printPackSlip', printPackingSlipComponent)

  .name;

export default printPackingSlipModule;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_packing_slip/index.js